import api from 'api';
import { actions, withAuth } from 'store';
import { checkAuthStrategyLoginRedirect, getNextPath } from 'lib/auth';
import { ErrorPage } from 'components/error';
import { CourseLogin } from 'components/login';

import type { NextPage } from 'next';
import type { GetCourseInfoRes } from 'shared-types/responses';

interface Props {
  course?: GetCourseInfoRes['course'];
  next?: string | null;
}

const CourseLoginPage: NextPage<Props> = ({ course, next }) =>
  !course ? (
    <ErrorPage statusCode={404} />
  ) : (
    <CourseLogin course={course} next={next} />
  );

CourseLoginPage.getInitialProps = async ({
  asPath,
  query,
  reduxStore,
  res,
  req
}) => {
  const courseSlug = (asPath || '').split('/')[3].split('?')[0];
  if (!courseSlug) return {};

  const headers = req?.headers?.cookie ? { Cookie: req.headers.cookie } : {};
  const response = await api.get(`/auth/course-info?slug=${courseSlug}`, {
    ...(headers.Cookie ? { headers } : {})
  });
  const course = response.data.course;
  if (!course) return {};

  const next = query.next ? getNextPath(asPath) : course.url;

  const redirect = checkAuthStrategyLoginRedirect({ next, reduxStore, res });
  if (redirect) return {};

  reduxStore.dispatch(
    actions.setInitialPageState({
      course: course,
      courseLogin: true,
      error: null,
      loading: false
    })
  );
  return { course, next };
};

export default withAuth(['PUBLIC'])(CourseLoginPage);
